import { useEffect, useState } from 'react';

import { getElapsedTime } from './helpers';

import styles from './Timer.module.scss';

interface TimerProps {
    createdAt?: Date | string;
    finishedAt?: Date | string;
    isStatic?: boolean;
}

export const Timer: React.FC<TimerProps> = ({ createdAt, finishedAt, isStatic }) => {
    const [elapsedTime, setElapsedTime] = useState(getElapsedTime(createdAt, finishedAt));

    useEffect(() => {
        if (isStatic || !createdAt) {
            return;
        }

        const updateElapsedTime = () => {
            const seconds = getElapsedTime(createdAt, finishedAt);
            setElapsedTime(seconds);
        };

        updateElapsedTime();
        const intervalId = setInterval(updateElapsedTime, 100); // update every 100ms
        return () => clearInterval(intervalId);
    }, [createdAt, finishedAt, isStatic]);

    if (!createdAt) {
        return null;
    }

    return <span className={styles.timer}>{elapsedTime}</span>;
};
